export default __webpack_public_path__ + "static/media/Unknown.65718e15.jpg";